module.exports = __webpack_public_path__ + "p4_img1.jpg?27f4b3e3942ec73eaee4961d10bd7c6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img1.jpg
// module id = 120
// module chunks = 0